export default __webpack_public_path__ + "static/media/INXC_old.97706bc6.png";